import { render, staticRenderFns } from "./VDataTableCustom.vue?vue&type=template&id=ce54a6f4&scoped=true"
import script from "./VDataTableCustom.vue?vue&type=script&lang=js"
export * from "./VDataTableCustom.vue?vue&type=script&lang=js"
import style0 from "./VDataTableCustom.vue?vue&type=style&index=0&id=ce54a6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce54a6f4",
  null
  
)

export default component.exports